import "./Tabs.css"
const TabComponent = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="row mb-3">
      {tabs.map((tab, index) => (
        <div key={tab.value} className="col-6">
          <button
            className={`${
              activeTab === tab.value ? "activeTab" : "deactivetab"
            }`}
            onClick={() => onTabChange(tab.value)}
          >
            {tab.label}
          </button>
        </div>
      ))}
    </div>
  );
};
 
export default TabComponent;